import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Button from 'UIKit/Button'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { Time } from 'config/constants'
import { UserBonus } from 'config/types/bonus/userBonus'
import useModal from 'hooks/useModal'
import { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useBonusAction, useVerifyActivableBonuses } from 'state/bonus/hooks'
import { useInvalidActiveCashbackBonus } from 'state/bonus/hooks/cashbackBonus'
import { Icons } from 'svgs'
import { timeLeftUnitV2 } from 'utils'
import BonusDetailsModal from 'views/BonusCenter/components/BonusDetailsModal'
import { ValidatedBonusStatusEnums, useDisplayBonusName, useValidateBonus } from 'views/BonusCenter/hooks'

const BonusTooltipItem = ({ bonus }: { bonus: UserBonus }) => {
  const { submit, actionContent } = useBonusAction(bonus)
  const verifier = useVerifyActivableBonuses(bonus)
  const {
    preventedByActiveCashbackBonus,
    cashbackBonusPreventedByActiveWageringBonus,
    cashbackBonusPreventedByActiveCashbackBonus,
  } = useInvalidActiveCashbackBonus(bonus)

  const handleVerifyAndApplyBonus = useCallback(
    (e) => {
      e.stopPropagation()
      verifier((isSuccess) => {
        if (isSuccess) {
          submit()
        }
      })
    },
    [verifier],
  )

  const { t } = useTranslation()
  const [name] = useDisplayBonusName(bonus.info?.name)
  const [timeLeftDisplayTemplate, timeAmount] = timeLeftUnitV2(bonus?.condition?.expiryDate, {
    [Time.MIN]: ['min', 'mins'],
  })

  const [onPresentBonusDetailModal] = useModal(BonusDetailsModal)

  const validatedResult: ValidatedBonusStatusEnums = useValidateBonus(bonus)

  return (
    <Flex
      height="36px"
      width="100%"
      justifyContent="space-between"
      onClick={() => (bonus ? onPresentBonusDetailModal({ bonus }) : null)}
      style={{ cursor: 'pointer' }}
    >
      <Flex width="100%">
        <Box width={36} height={36}>
          <Image src={bonus.info.image} width={36} height={36} />
        </Box>
        <Flex flexDirection="column" marginLeft="4px" width="100%" height="36px" justifyContent="space-between">
          <Flex justifyContent="space-between" alignItems="center" width="100%" height="17px">
            <Text fontSize="14px" fontWeight={500} letterSpacing={-0.28} ellipsis={1} maxWidth="70%">
              {name}
            </Text>
            {validatedResult === ValidatedBonusStatusEnums.Available &&
              ![
                !!preventedByActiveCashbackBonus ||
                  cashbackBonusPreventedByActiveCashbackBonus ||
                  cashbackBonusPreventedByActiveWageringBonus,
              ].includes(true) && (
                <Flex alignItems="center">
                  <Button
                    variant="text"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleVerifyAndApplyBonus(e)
                    }}
                    p="0px !important"
                    marginRight="4px"
                  >
                    <Text fontSize="10px" fontWeight="600" color="primary">
                      <Trans>{actionContent}</Trans>
                    </Text>
                  </Button>
                  <Icons.ArrowRightPrimaryColorIcon />
                </Flex>
              )}
          </Flex>

          <Text fontSize="12px" fontWeight={500} marginTop="4px" color="textAlt1" letterSpacing={0.24}>
            {t(`${timeLeftDisplayTemplate} left`, {
              time: timeAmount,
            })}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default BonusTooltipItem
